var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebsites(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 80,
    viewBox: "0 0 212 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(60 10)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 1.25,
    width: 94.5,
    height: 64.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.129 23.725 79.7 23.71a3 3 0 0 1 3.002 3.002L82.69 44.4a3 3 0 0 1-2.998 2.998l-22.572.015a3 3 0 0 1-3.002-3.002l.013-17.688a3 3 0 0 1 2.998-2.998Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m59.221 40.14 3.445-2.71a1.353 1.353 0 0 1 1.644.013l2.51 2.007c.125.1.313.095.431-.013l4.415-4.05a1.347 1.347 0 0 1 1.788-.002c.032.03.062.06.09.092L77.6 40.2M94.233 11.338H19.52h74.712Zm-53.27 18.554h-28.59 28.59Zm.221 6.185H12.28h28.904Zm0 6.185H12.28h28.904Zm0 6.184H12.28h28.904ZM14.416 11.338H3.063h11.353Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M60 16v57a4 4 0 0 0 4 4h89a4 4 0 0 0 4-4V16h26c3.866 0 7 3.582 7 8s-3.134 8-7 8h22c3.866 0 7 3.582 7 8s-3.134 8-7 8h-19c-3.866 0-7 3.582-7 8s3.134 8 7 8h6c3.866 0 7 3.582 7 8s-3.134 8-7 8h-52a6.186 6.186 0 0 1-1.5-.184c-.483.12-.985.184-1.5.184H46c-3.866 0-7-3.582-7-8s3.134-8 7-8H7c-3.866 0-7-3.582-7-8s3.134-8 7-8h40c3.866 0 7-3.582 7-8s-3.134-8-7-8H22c-3.866 0-7-3.582-7-8s3.134-8 7-8h38Zm0-.331c-2.891-.984-5-4.045-5-7.669 0-4.418 3.134-8 7-8h57c3.866 0 7 3.582 7 8a9.1 9.1 0 0 1-.22 2H64a4 4 0 0 0-4 4v1.669Z",
    fillOpacity: 0.3,
    fill: "#7F7F7F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsites);
export default __webpack_public_path__ + "static/media/websites.b195af7ad5faaef6f325bc8e4c4fea93.svg";
export { ForwardRef as ReactComponent };